/**
 * Created by huc on 06.16.2018. 
 */
import BootstrapMenu        from 'bootstrap-menu';

import assetCollection from 'AssetCollection';
import listService from 'ListService';
import assetView from 'AssetView';
import focusController  from 'FocusController.js';
import Immutable from 'immutable';
import constants from 'Constants';
import util from 'util/Util';

import StyleView from 'properties/StyleView';
import BehaviorView from 'properties/BehaviorView';
import AttributesView from 'properties/AttributesView'
import TabSettingsView from 'properties/TabSettingsView';
import TabAccessView from 'properties/TabAccessView'; 

//===============================================================
// A Backbone collection of a Form's Asset models.
// Each model has a reference to the Asset id, name, type and mimetype.
//===============================================================
class AssetUI {

    initialize() { 
        
    }

    showAssets() {

        const self = this;
        $('#factories .asset').remove();
        listService.selectedAsset = null;

        assetCollection.forEach(asset => { 
            var newAsset = new assetView({model: asset});
            newAsset.render();
        });

        let deleteBtn =  $('#asset_delete').find('.toolbar-button');
         
        if (assetCollection.length < constants.maxItemOnSlide - 1) {
            $(".left.carousel-control").addClass("disable_a_href");
            $(".right.carousel-control").addClass("disable_a_href");
        } 
        else {
            $(".left.carousel-control").removeClass("disable_a_href");
            $(".right.carousel-control").removeClass("disable_a_href");
        }

        if (!assetCollection.length) {
            deleteBtn.addClass('btn-disabled');
        }

        $('#common-carousel div').removeClass('active'); 
        $('#common-carousel div:first-child').addClass('active');

        $('#common-carousel div.asset_delete > div').addClass('btn-disabled');

        $(".asset p").on('dblclick', function(ev) {
            ev.stopPropagation();
            self.showFieldAssetName(ev);
        });
    }

    getCurrentAssetId(id){
        const asset = $('#' + id);
        return asset.data('asset-id');
    }

    assetClicked(ev, context, id = null) {
        focusController.clearAllSelected();
        $('.asset_delete div.btn-disabled').removeClass('btn-disabled');

            listService.objectList.map(view => {
                if (view.subviews) {
                    view.subviews.map((propertyView) => {
                        propertyView.undelegateEvents();
                    });
                }
            });

            const selectedId = id || this.getCurrentAssetId(ev.currentTarget.id);
            $('div.asset div.asset-selected').removeClass('selected');
            $('#' + selectedId).find('div.asset-selected').addClass('selected');

            const selectedAsset = assetCollection.findWhere({assetId: selectedId});

            listService.selectedAsset = selectedAsset;

            context._subviews = Immutable.Map()
                .set('styleView', new StyleView({model: selectedAsset, el: $(constants.PROP_STYLE_ID)}))
                .set('behaviorView', new BehaviorView({model: selectedAsset, el: $(constants.PROP_BHVR_ID)}))
                .set('attributesView', new AttributesView({model: selectedAsset, el: $(constants.PROP_ATTRIBUTES_ID)}))
                .set('settingsView', new TabSettingsView({model: selectedAsset, el: $(constants.PROP_SETTNGS_ID)}))
                .set('accessView', new TabAccessView({model: selectedAsset, el: $(constants.PROP_ACCESS_SECTION)}));

            if (context._subviews) {
                context.delegateEvents();
                context._subviews.map(pview => {
                    pview.render();
                    pview.delegateEvents();
                });
            }  
    }

    deleteAsset(context) {
        this.showLabelAssetName();

        let assetExists = listService.objectList.toArray().some(element => 
            element.model.get('assetId') && element.model.get('assetId') === listService.selectedAsset.id
        );

        if (assetExists) {
            const titleWarning = 'This image is in use and cannot be deleted.';
            let simpleModal = util.createDialogDeleteConfirmation("Delete Image", titleWarning, false, 120);
             
            simpleModal.render()
                .then((result) => { });
        } else {
            context.execDeleteAsset();
            $('.asset_delete div').addClass('btn-disabled');
        }
    }

    showFieldAssetName(ev) {
        ev.stopPropagation();

        //PF-4951 Remove draggable while editing asset name because if parent is draggable children inputs can't have selectable text in Firefox, Edge and IE11
        const assetId = '#' + listService.selectedAsset.id;
        const asset = $(assetId);
        asset.removeAttr("draggable");

        this.showLabelAssetName();

        const assetEdit = $("#asset-edit-" + listService.selectedAsset.id);

        $("#asset-label-" + listService.selectedAsset.id).css('display', 'none');
        assetEdit.css('display', 'block');
        assetEdit.focus();
    }

    showLabelAssetName() {
        $(".edit-asset-name").css('display', 'none');
        $(".label-asset-name").css('display', 'block');
    }

    
    changeAssetName(ev) {
        ev.stopPropagation();
        const self = this;

        let hideControls = () => {

            const assetId = self.getCurrentAssetId(ev.currentTarget.id);
            $("#asset-label-" + assetId).css('display', 'block');
            $("#asset-edit-" + assetId).css('display', 'none');

            let asset = assetCollection.models.find(m => m.get('id') === assetId);
            let newName = $("#asset-edit-" + assetId).val().trim();
            $("#asset-label-" + assetId).text(newName).prop('title', newName); 
            $(".attribute-options #propMainName input[name='name']").val(newName);

            asset.set('name', newName + '.' + asset.get('extension'), {silent: true});
            asset.set('tmpName', newName, {silent: true});

            //PF-4951 Assign draggable attribute after done editing.
            const $asset = $('#' + assetId);
            $asset.attr('draggable','true');
        };

        if (ev.keyCode === 13 || ev.which === 27 || ev.type === "focusout") { 
            hideControls();
        }
    }

    attachRightClickMenu(context) {
        let that = this; 
        if (context.contextMenus && typeof context.contextMenus.destroy === 'function') {
            context.contextMenus.destroy();
        }

        context.contextMenus = new BootstrapMenu('.asset-has-menu', {
            fetchElementData: function($elm) {
                return $elm;
            },
            actions: [{
                name: 'Delete',
                iconClass:'pf-delete',
                onClick: function(elm) {
                    that.showLabelAssetName();
                    that.assetClicked(null, context, $(elm).data("asset-id"));
                    context.deleteAsset();
                } 
            }]
        });
    }

    calculateItemsPerSlide(template) {
        let defaultItems = 1;
        let carousel = $('.carousel-inner'); 
        if (!carousel.length) {
            carousel = $('#factories');
        }

        let width = carousel.width();
        let itemWidth = 94;
        if (template === 'assets') {
            width -= 155; //total with of add/delete assets buttons in px
            defaultItems = 2;
            itemWidth = 94;
        } 

        if(template === 'common'){
            width = width - itemWidth; //Account for width of settings button
        }

        let items = Math.round(width / itemWidth);
        

        console.log(carousel, width, Math.floor(width / itemWidth));


        return items + defaultItems; 
    }
}

export default new AssetUI();
